import { getOsgIDCAllConfig, getOsgBrowserCompassByKey } from '@osgfe/web-compass';

const compassConfig = getOsgIDCAllConfig({
    idc: process_env_publishIdc,
    env: process_env_compassEnv,
});

export const loginUrl = `https://${compassConfig.partnerKeemartHost}`;
export const signupUrl = `${getOsgBrowserCompassByKey({ key: 'partnerKeemartHost', needProtocol: true })}/signup.html?locale=en`;
